import swaggerClient from "../remote-client";

export default class NotificationsServiceImpl {
  /**
   * Retrieve the number of the unread notifications for the given office
   */
  callGetNotificationsUnreadCount(officeId) {
    return new Promise((resolve, reject) => {
      swaggerClient.hfportalSwaggerClient
        .then(client => {
          return client.apis.Notification.getNotificationsOfficeWithOfficeIdUnreadCount(
            { officeId: officeId },
            swaggerClient.buildRequest(),
            {}
          );
        })
        .then(result => {
          let numberOfUnreadNotifications = 0;
          if (result.body && result.body.num) {
            numberOfUnreadNotifications = result.body.num;
          }
          resolve(numberOfUnreadNotifications);
        })
        .catch(error => reject(error));
    });
  }
  /**
   * Retrieve all the notifications for the given filters, included the given office (paginated)
   * @param {*} payload
   */
  callGetNotifications(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.hfportalSwaggerClient
        .then(client => {
          return client.apis.Notification.getNotificationsOfficeWithOfficeId(
            payload,
            swaggerClient.buildRequest(),
            {}
          );
        })
        .then(result => {
          let notifications = [];
          let numberOfNotifications = 0;
          if (result.body && result.body.notifications) {
            notifications = result.body.notifications;
            numberOfNotifications = result.body.totalNumber;
          }
          resolve({
            notifications: notifications,
            numberOfNotifications: numberOfNotifications
          });
        })
        .catch(error => reject(error));
    });
  }
  /**
   * Mark as read the given notification of the given office
   * @param {*} payload
   */
  callMarkNotificationAsRead(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.hfportalSwaggerClient
        .then(client => {
          return client.apis.Notification.postNotificationWithNotificationIdOfficeWithOfficeIdRead(
            payload,
            swaggerClient.buildRequest(),
            {}
          );
        })
        .then(() => {
          resolve();
        })
        .catch(error => reject(error));
    });
  }
}
